// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"1ac88c33","175":"01982635","204":"4f18ef97","235":"5107f2c7","527":"95bbf2de","721":"b462883e","850":"980da8da"}[chunkId] + ".css";
};